module.exports = __webpack_public_path__ + "img/etherscan-logo.94eac478.png";